import React, {
    FC,
    useEffect,
    useState,
} from 'react';

import {CustomTable} from 'components/@common/widgets/custom-table';
import {ModalOpenerComponent} from 'components/modal-opener-component';
import {createStringDate} from 'components/table/utils/table.utils';
import {selectContextRawData} from 'modules/context/context-selector';
import {DATE_WITH_TIME_DOTS_SECONDS_24} from 'shared/constants/date-format';
import {TStateSetter} from 'shared/types/generics';
import {useAppSelector} from 'store/config/hooks';
import {selectMicroserviceToken} from 'store/slices/auth-slice/auth-slice-selectors';
import {IEtlSubAuditDto, fetchEtlSubAudit} from 'store/slices/etl-slice';

interface IAuditDownloadManagerModalProps {
    loadId?: number;
    isOpen: boolean;
    setOpen: TStateSetter<boolean>;
}

export const AuditDownloadManagerModal: FC<IAuditDownloadManagerModalProps> = ({
    loadId,
    isOpen,
    setOpen,
}: IAuditDownloadManagerModalProps) => {
    const [subAuditData, setSubAuditData] = useState<IEtlSubAuditDto[]>();
    const [loading, setLoading] = useState(false);

    const token = useAppSelector(selectMicroserviceToken);
    const {organizationId} = useAppSelector(selectContextRawData) ?? {};

    useEffect(() => {
        if (isOpen && token && loadId) {
            (async () => {
                try {
                    setLoading(true);
                    const data = await fetchEtlSubAudit({loadId, organizationId});
                    setSubAuditData(data.data);
                    setLoading(false);
                } catch (e) {
                    setLoading(false);
                }
            })();
        }
    }, [token, loadId, isOpen]);

    const columns = [
        {
            title: 'Дата и время',
            dataIndex: 'startOperDate',
            key: 'startOperDate',
            render: (value: string) => (
                <span>{createStringDate(value, DATE_WITH_TIME_DOTS_SECONDS_24)}</span>
            ),
        },
        {
            title: 'Действие',
            dataIndex: 'operName',
            key: 'operName',
        },
        {
            title: 'Статус',
            dataIndex: 'meaning',
            key: 'meaning',
        },
        {
            title: 'Сообщение',
            dataIndex: 'responseBody',
            key: 'responseBody',
        },
    ];

    return (
        <ModalOpenerComponent
            isOpen={isOpen}
            setIsOpen={setOpen}
            isLoading={loading}
            hideControls={{all: true}}
            modalProps={{
                forceRender: false,
                destroyOnClose: true,
                centered: true,
                width: 1480,
                title: 'Аудит действий менеджера загрузки',
            }}
        >
            <CustomTable
                dataSource={subAuditData}
                columns={columns}
                pagination={false}
            />
        </ModalOpenerComponent>
    );
};
